import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { useParams } from 'react-router'
import { RequestTableParamsType } from 'views/RequestsManagement/components/NewRequestsTable/types/new-requests-table.types'
import { queryClient } from '../../../App'
import { getRequestToReport } from '../../../services/ApiService'
import { CheckboxStore } from '../../../stores/CheckboxStore'
import NewPaginationStore from '../../../stores/NewPaginationStore'
import { getComp } from '../../../utils/utils/DI'
import { REPORT_KEYS } from '../../SingleRequestReport/consts/request-report.keys'

const initParams: RequestTableParamsType = {}

export const addToReportPaginationStore = new NewPaginationStore(initParams)

export const addToReportCheckboxStore = new CheckboxStore()

export const useAddToReportTableData = () => {
  const { reportId } = useParams()
  const {
    page,
    size,
    sort,
    params: { address, installedFrom, installedTo, fullName, orderId, phone },
  } = addToReportPaginationStore

  const userId = getComp('UserInfoStore')?.info?.id

  const enabled = !!userId || !!reportId || !!Number.isNaN(Number(reportId))

  return useQuery(
    {
      queryKey: [
        REPORT_KEYS.ADD,
        size,
        page,
        sort,
        address,
        installedFrom,
        installedTo,
        fullName,
        orderId,
        phone,
        userId,
        reportId,
      ],
      queryFn: () =>
        getRequestToReport({
          reportId: Number(reportId),
          size,
          page,
          address,
          installedFrom,
          installedTo,
          fullName,
          orderId,
          phone,
          sort: sort ?? undefined,
        }),
      staleTime: 1000000,
      placeholderData: keepPreviousData,
      enabled: () => !!enabled,
    },
    queryClient,
  )
}
